module.exports = __webpack_public_path__ + "img/190_G_1530778923920.6b07d736.jpg";